import {
  GET_FILTERD_SALE,
  GET_MINE_SALE_ORDER_DETAILS,
  GET_SALE,
  GET_SALE_BY_ID,
  GET_SALE_MINE,
  GET_SALE_ORDER_DETAILS,
  GET_SALE_REQUEST_BY_ID,
} from "../constants/index";

export const sale = (
  state = {
    getsalelist: [],
    getsalebyid: {},
    getminesalelist: [],
    getfilterdsale: {},
    minesaleorderlist: {},
    saleorderlist: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SALE:
      return { ...state, getsalelist: action.getsalelist };
    case GET_SALE_MINE:
      return { ...state, getminesalelist: action.getminesalelist };
    case GET_SALE_BY_ID:
      return { ...state, getsalebyid: action.getsalebyid };
    case GET_SALE_REQUEST_BY_ID:
      return { ...state, getsalerequestbyid: action.getsalerequestbyid };
    case GET_FILTERD_SALE:
      return { ...state, getfilterdsale: action.getfilterdsale };
    case GET_MINE_SALE_ORDER_DETAILS:
      return { ...state, minesaleorderlist: action.minesaleorderlist };
    case GET_SALE_ORDER_DETAILS:
      return { ...state, saleorderlist: action.saleorderlist };
    default:
      return state;
  }
};
